const toLocalISO = (d) => {
  const y = d.getFullYear(), m = String(d.getMonth()+1).padStart(2,'0'), day = String(d.getDate()).padStart(2,'0');
  return `${y}-${m}-${day}`;
};
export const today   = toLocalISO(new Date());
export const daysAgo = n => { const d = new Date(); d.setDate(d.getDate()-n); return toLocalISO(d); };
export const monthAgo = () => {
  const d = new Date();
  d.setMonth(d.getMonth() - 1);
  return toLocalISO(d);
};

export const PRESETS = [
  { label: 'Today',    start: today,  end: today },
  { label: 'Last 7d',  start: daysAgo(6),   end: today },
  { label: 'Last 15d', start: daysAgo(14),  end: today },
  { label: 'One Month', start: monthAgo(), end: today },
];

export default function DateBar({ start, end, preset, setStart, setEnd, setPreset, loading }) {
  return (
    <div className="date-bar">
      <div style={{
        display: 'flex', alignItems: 'center',
        gap: '8px', flexWrap: 'wrap',
      }}>

        {/* Preset buttons */}
        {PRESETS.map((p, i) => (
          <button key={p.label} className={`preset-btn ${preset === i ? 'active' : ''}`}
            onClick={() => { setPreset(i); setStart(p.start); setEnd(p.end); }}>
            {p.label}
          </button>
        ))}

        {/* Divider */}
        <div style={{ width: '1px', height: '24px', background: 'var(--border)', margin: '0 4px' }} />

        {/* ✅ From date — same line */}
        <label style={{ fontSize: '12px', color: 'var(--muted)', fontWeight: 500 }}>From</label>
        <input
          type="date"
          value={start}
          className="date-input"
          onChange={e => { setPreset(-1); setStart(e.target.value); }}
        />

        {/* ✅ To date — same line */}
        <label style={{ fontSize: '12px', color: 'var(--muted)', fontWeight: 500 }}>To</label>
        <input
          type="date"
          value={end}
          className="date-input"
          onChange={e => { setPreset(-1); setEnd(e.target.value); }}
        />

        {loading && <span className="spinner" />}
      </div>
    </div>
  );
}